import { createFileRoute } from '@tanstack/react-router';
import { StoragePage } from '@/features/admin';

export const Route = createFileRoute('/_auth/o/$orgId/admin/storage')({
  component: StoragePage,
});
